import menu from './menuApi'
import dict from './dictApi'

export default {
  menu,
  dict,
}
